import React from 'react';
import { Navigate } from 'react-router-dom';

function Settings({ userData }) {
    if (!userData) {
        return <Navigate to="/" replace />;
    }

    return <Navigate to="/members/settings/inventory" replace />;
}

export default Settings;